import styled from 'styled-components'
import { colors } from '../components/colors'
import mapBackground from '../images/map_background.jpg'

export const ButtonsContainer = styled.div<{ $bottom?: boolean }>`
  margin: 10px 8px;
  position: absolute;
  display: flex;
  flex-direction: ${(props) => (props.$bottom ? 'row' : 'column')};
  gap: 0.3rem;
  z-index: 1;
  ${(props) =>
    props.$bottom &&
    `
    flex-direction: row;
    bottom: 10px;
  `}
`

export const MapContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${colors.Map.background};
  background-image: url(${mapBackground});
  background-repeat: repeat;
`

export const InfoContainer = styled.div`
  z-index: 1;
  position: absolute;
  font: 12px/20px Helvetica Neue, Arial, Helvetica, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 105px;
  width: 100%;
`

export const MessageContainer = styled.div`
  color: ${colors.Map.text};
  background-color: white;
  border-radius: 4px;
  padding: 4px 8px;
  margin: 0 15px;
  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.31);
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.31);
`

export const MapDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d86d1e;
  margin: 10px 0;
`

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const ImgContainer = styled.div`
  width: 60px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
`
